import { CredentialsListFilters, SEARCH_FILTER_OPTIONS } from '@accredible-frontend-v2/models';

export const CREDENTIALS_LIST_FILTERS_STORAGE_KEY = 'credentials_list_filters';

export const CREDENTIALS_LIST_PAGE_SIZE = 20;

export const INITIAL_CREDENTIALS_FILTERS = <CredentialsListFilters>{
  page: 1,
  page_size: CREDENTIALS_LIST_PAGE_SIZE,
  selectedGroups: [],
  visibility: null,
  status: null,
  searchTerm: '',
  searchType: SEARCH_FILTER_OPTIONS.TEXT_FIELDS,
  engagement: {},
  customAttributes: [],
  dateRange: {
    start: null,
    end: null,
  },
  departmentId: null,
  sort: {
    active: 'issued_on',
    direction: 'desc',
  },
  languages: [],
  selectedCollections: [],
};
